import {createActions} from 'redux-actions';

const { clearAssessmentForm,
  changeAssessmentName,
  changeSubsectionTitle,
  removeSubsection,
  addSubsection,
  addQuestion,
  removeQuestion,
  updateQuestion } = createActions('CLEAR_ASSESSMENT_FORM', 'CHANGE_ASSESSMENT_NAME', 'CHANGE_SUBSECTION_TITLE', 'REMOVE_SUBSECTION', 'ADD_SUBSECTION', 'ADD_QUESTION', 'REMOVE_QUESTION', 'UPDATE_QUESTION');

export { clearAssessmentForm,
  changeAssessmentName,
  changeSubsectionTitle,
  removeSubsection,
  addSubsection,
  addQuestion,
  removeQuestion,
  updateQuestion };


// WEBPACK FOOTER //
// ./src/components/utils/actions/createAssessment.js